import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import Hold from '@/views/Hold.vue'
import MyPage from '@/views/MyPage.vue'
import EventPage from '@/views/EventPage.vue'
import Login from '@/views/Login.vue'
import { getSecureStorage, SECURE_STORAGE_KEY } from '@/utils/security'

const routes = [
  { path: '/login', component: Login },
  { path: '/', component: HomePage, meta: { requiresAuth: true } },
  { path: '/hold', component: Hold, meta: { requiresAuth: true } },
  { path: '/mypage', component: MyPage, meta: { requiresAuth: true } },
  { path: '/event', component: EventPage, meta: { requiresAuth: true } }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const user = getSecureStorage(SECURE_STORAGE_KEY)
  
  if (to.meta.requiresAuth && !user) {
    next('/login')
  } else if (to.path === '/login' && user) {
    next('/mypage')
  } else {
    next()
  }
})

export default router
